module.exports = __webpack_public_path__ + "img/type_STEEL.952e8fbf.png";